export default __webpack_public_path__ + "static/media/fevr-bm-icon-1.b327ae06.svg";